export default [
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'ID',
    },
    cell: {
      type: 'text',
      value: (e) => e.id,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Name',
    },
    cell: {
      type: 'slot',
      name: 'name',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Shorten name',
    },
    cell: {
      type: 'slot',
      name: 'shortenName',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Type',
    },
    cell: {
      type: 'slot',
      name: 'type',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Logo',
    },
    cell: {
      type: 'slot',
      name: 'logo',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: '',
    },
    cell: {
      type: 'slot',
      name: 'isEnabled',
    },
  },
];
